var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TextInput, useFocusWithin, useMobile } from '@gravity-ui/uikit';
import { useDateFieldProps, useDateFieldState } from '../DateField';
import { DesktopCalendar, DesktopCalendarButton } from './DesktopCalendar';
import { MobileCalendar, MobileCalendarIcon } from './MobileCalendar';
import { useDatePickerState } from './hooks/useDatePickerState';
import { b } from './utils';
import './DatePicker.css';
export function DatePicker(_a) {
    var { value, defaultValue, onUpdate, className, onFocus, onBlur } = _a, props = __rest(_a, ["value", "defaultValue", "onUpdate", "className", "onFocus", "onBlur"]);
    const anchorRef = React.useRef(null);
    const state = useDatePickerState(Object.assign(Object.assign({}, props), { value,
        defaultValue,
        onUpdate }));
    const [isMobile] = useMobile();
    const [isActive, setActive] = React.useState(false);
    const { focusWithinProps } = useFocusWithin({
        onFocusWithin: onFocus,
        onBlurWithin: onBlur,
        onFocusWithinChange(isFocusWithin) {
            setActive(isFocusWithin);
        },
    });
    const fieldState = useDateFieldState({
        value: state.value,
        onUpdate: state.setValue,
        disabled: state.disabled,
        readOnly: state.readOnly,
        validationState: props.validationState,
        minValue: props.minValue,
        maxValue: props.maxValue,
        isDateUnavailable: props.isDateUnavailable,
        format: state.format,
        placeholderValue: props.placeholderValue,
        timeZone: props.timeZone,
    });
    const { inputProps } = useDateFieldProps(fieldState, props);
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    _jsxs("div", Object.assign({ ref: anchorRef, className: b(null, className), style: props.style }, focusWithinProps, { role: "group", "aria-disabled": state.disabled || undefined, onKeyDown: (e) => {
            if (e.altKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
                e.preventDefault();
                e.stopPropagation();
                state.setOpen(true);
            }
        }, children: [isMobile ? (_jsx(MobileCalendar, { props: props, state: state })) : (_jsx(DesktopCalendar, { anchorRef: anchorRef, props: props, state: state })), _jsx(TextInput, Object.assign({}, inputProps, { value: fieldState.isEmpty && !isActive && props.placeholder ? '' : inputProps.value, className: b('field', { mobile: isMobile }), hasClear: !isMobile && inputProps.hasClear, rightContent: isMobile ? (_jsx(MobileCalendarIcon, { props: props, state: state })) : (_jsx(DesktopCalendarButton, { props: props, state: state })) }))] })));
}
